import { useCallback, useState } from 'react';
import { KEY_STORAGE } from '../lib.js';

const LEGACY_KEY_STORAGE = 'videocaptioner-api-key';

export function readStoredApiKey() {
  try {
    const value = localStorage.getItem(KEY_STORAGE)
      || localStorage.getItem(LEGACY_KEY_STORAGE)
      || sessionStorage.getItem(LEGACY_KEY_STORAGE)
      || '';
    if (value) localStorage.setItem(KEY_STORAGE, value);
    localStorage.removeItem(LEGACY_KEY_STORAGE);
    sessionStorage.removeItem(LEGACY_KEY_STORAGE);
    return value;
  } catch {
    return '';
  }
}

export function useStoredApiKey() {
  const [apiKey, setApiKeyState] = useState(readStoredApiKey);

  const saveApiKey = useCallback((value) => {
    const normalized = String(value || '').trim();
    try {
      if (normalized) localStorage.setItem(KEY_STORAGE, normalized);
      else localStorage.removeItem(KEY_STORAGE);
    } catch {
      // Private browsing or strict storage policies can disable localStorage.
    }
    setApiKeyState(normalized);
    return normalized;
  }, []);

  const clearApiKey = useCallback(() => saveApiKey(''), [saveApiKey]);

  return { apiKey, setApiKey: saveApiKey, clearApiKey };
}
